<!--lifted from DBG web site-->
<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    :width="props.width"
    :height="props.height"
    :fill="props.fill"
    color="white"
    viewBox="0 0 672.41 300.1"
  >
    <path
      class="cls-1"
      d="m229.07,140.87c0-69.77-55.86-95.9-122.53-95.9H38.11v106.33h45.62v-67.53h26.9c38.6,0,71.06,17.51,71.06,54.95,0,43.37-31.88,58.18-74.28,58.18h-23.69s-45.62,0-45.62,0v38.79h74.57c61.7,0,116.39-33.13,116.39-94.82Z"
    />
    <path
      class="cls-1"
      d="m565.87,235.69h68.43v-106.33h-45.62v67.53h-26.9c-38.6,0-71.06-17.51-71.06-54.95,0-43.37,31.88-58.18,74.28-58.18h23.69s45.62,0,45.62,0v-38.79h-74.57c-61.7,0-116.39,33.13-116.39,94.82,0,69.77,55.86,95.9,122.53,95.9Z"
    />
    <path
      class="cls-1"
      d="m434.25,182.63c0-24.78-18.13-43.37-45.33-46.6v-.54c21.35-6.2,35.68-20.74,35.68-42.02,0-41.48-39.48-48.49-75.74-48.49h-105.16v190.72h112.77c36.85,0,77.79-13.2,77.79-53.07Zm-144.94-102.09h58.96c14.33,0,30.71,4.04,30.71,19.93s-14.62,20.74-28.66,20.74h-15.33v35.56h16.79c14.92,0,36.85,2.96,36.85,21.01,0,16.7-16.08,22.36-30.41,22.36h-68.9v-119.6Z"
    />
    <polygon class="cls-1" points="278.66 283.68 285.34 283.68 282.03 275.95 278.66 283.68" />
    <path
      class="cls-1"
      d="m0,0v300.1h672.41V0H0Zm56.35,290.93h-3.82v-8.38h-10.04v8.38h-3.82v-19.01h3.82v7.57h10.04v-7.57h3.82v19.01Zm116.49,0h-14.77v-19.01h14.23v3.06h-10.4v4.67h9.86v3.06h-9.86v5.16h10.95v3.06Zm115.83,0l-2-4.35h-9.31l-1.94,4.35h-4.28l9.34-19.01h3.31l9.25,19.01h-4.37Zm116.65,0h-12.96v-19.01h3.82v15.95h9.13v3.06Zm111.74-15.95h-6.58v15.95h-3.82v-15.95h-6.58v-3.06h16.99v3.06Zm117.23,15.95h-3.82v-8.38h-10.04v8.38h-3.82v-19.01h3.82v7.57h10.04v-7.57h3.82v19.01Zm29.25-29.37H8.87V19.09h654.66v242.48Z"
    />
  </svg>
</template>

<script setup lang="ts">
interface SVGProps {
  height: string
  width: string
  fill: string
}

const props = defineProps<SVGProps>()
</script>
